import React, { useState } from 'react'
import { FileTextOutlined } from "@ant-design/icons";


export default function FileTextIcon() {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FileTextOutlined
            style={{
                fontSize: "24px",
                color: !isHovered ? "rgb(163, 149, 218)" : "#1890ff",
                cursor: "pointer",
                transition: "transform 0.3s ease, color 0.3s ease",
                transform: isHovered ? "scale(1.2)" : "scale(1)",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        />
    );

}
